import { useContext, useEffect } from 'react';
import type { Navigator } from 'react-router';
import { UNSAFE_NavigationContext } from 'react-router-dom';

/**
 * Blocks in-app navigation and asks the user to confirm when `when` is true.
 */
const useNavigationBlocker = (when: boolean, message?: string) => {
    const navigation = useContext(UNSAFE_NavigationContext);

    useEffect(() => {
        if (!when || !navigation) {
            return;
        }

        const { navigator } = navigation;
        const historyNavigator = navigator as Navigator & {
            block?: (blocker: (transition: { retry(): void }) => void) => () => void;
        };

        if (typeof historyNavigator.block !== 'function') {
            return;
        }

        const unblock = historyNavigator.block((transition) => {
            const confirmMessage = message || 'Je opname is nog bezig. Weet je zeker dat je wilt stoppen en verder gaan?';
            const shouldProceed = window.confirm(confirmMessage);

            if (shouldProceed) {
                unblock();
                transition.retry();
            }
        });

        return unblock;
    }, [message, navigation, when]);
};

export default useNavigationBlocker;
